import { render, staticRenderFns } from "./teamMoneyShenList.vue?vue&type=template&id=2bc3f91f&"
import script from "./teamMoneyShenList.vue?vue&type=script&lang=js&"
export * from "./teamMoneyShenList.vue?vue&type=script&lang=js&"
import style0 from "./teamMoneyShenList.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports